import { Link } from "react-router-dom";
import AlbumList from "../AlbumList";
import SongDisplayList from "../ViewAll/SongDisplayList";

interface DiscographyTabContentProps {
    titles: Song[] | null;
    albums: Album[] | null;
    artist_id: number;
}

const DiscographyTabContent: React.FC<DiscographyTabContentProps> = ({
    titles,
    albums,
    artist_id
}) => {
    return (
        <div className="tab-discography">
            {titles && titles[0] && (
                <div className="artist-title-details">
                    <div className="list-description">
                        {titles && titles.length > 0 && (
                            <h4>title tracks ({titles.length})</h4>
                        )}
                        <Link className="see-all" to={`./songs`} state={{ id: artist_id }}>
                            see all
                        </Link>
                    </div>
                    <hr />
                    <div className="display-list">
                        {titles.slice(0, 4).map((title) => (
                            <SongDisplayList
                                key={title.song_id}
                                song={title}
                                name={title.english_name}
                                s3_picture_url={title.s3_picture_url}
                                year={title.year}
                                artist={undefined}
                                artist_ids={undefined}
                            />
                        ))}
                    </div>
                </div>
            )}

            {albums && albums[0] && (
                <div className="artist-title-details">
                    <div className="list-description">
                        {albums.length > 0 && (
                            <h4>
                                albums ({albums.length})
                            </h4>
                        )}
                        <Link className="see-all" to={`./albums`} state={{ id: artist_id }}>
                            see all
                        </Link>
                    </div>
                    <hr />
                    <div className="display-list">
                        {albums.slice(0, 4).map((album) => (
                            <AlbumList key={album._id} album={album} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiscographyTabContent; 